import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import './Modal.css';
import { getAppEnv } from '../../../config/env';
type ModalProps = {
  show: boolean;
  customParentClass: string;
  onClose: () => void;
  children: React.ReactNode;
};

const env = getAppEnv();
const { PUBLIC_URL } = env.raw;

const Modal: React.FC<ModalProps> = ({
  show,
  onClose,
  children,
  customParentClass
}) => {
  useEffect(() => {
    if (show) {
      document.body.classList.add('modal-open');
    } else {
      document.body.classList.remove('modal-open');
    }

    return () => {
      document.body.classList.remove('modal-open');
    };
  }, [show]);

  if (!show) {
    return null;
  }

  const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return ReactDOM.createPortal(
    <div className="modal-overlay" onClick={handleOverlayClick}>
      <div
        className={`modal-container ${customParentClass || ''}`}
        role="dialog"
      >
        <div className="modal-close" onClick={onClose}>
          <img
            src={`${PUBLIC_URL}/static/public/cancel_cross.png`}
            width={24}
            height={24}
            alt=""
            className="cross-icon"
          />
        </div>
        <div className="modal-content">{children}</div>
      </div>
    </div>,
    document.body
  );
};

export default Modal;
